import $ from 'jquery';

$(function () {
  if ($('.companies.show').length) {
    $('.js-company-disable-confirm').click(function () {
      var subdomain = $('.js-disable-company-modal').data('subdomain');
      var inputSubdomain = $('.js-company-disable-input').val();
      if (subdomain !== inputSubdomain) {
        var alertText = $('.js-disable-company-modal').data('message');
        window.alert(alertText);
        return false;
      }
    });
  }
});
